export default __webpack_public_path__ + "static/media/y_a0cc3590.81f9a664.jpg";